import CanvasJSReact from "@/assets/canvasjs.react";
import { rainbowColors } from "@/pages/Dashboard/ComparisonTools";
import { colorSchemaList } from "@/utils/colorSchemas";
import { Spin } from "antd";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
var CanvasJS = CanvasJSReact.CanvasJS;

const CanvasjsPieChart = ({
  data = [],
  isLoading = false,
  isDark = false,
  height,
  legendPosition = "center bottom",
  colorSchema,
  doughnut,
  showPercentage,
  showValue,
}) => {
  const [dataPoints, setDataPoints] = useState([]);

  const scheme = colorSchemaList.others?.find((item) => item?.value === colorSchema);
  CanvasJS.addColorSet("pieShades", scheme?.colors || rainbowColors);

  useEffect(() => {
    let total = 0;
    let temp = (data || []).reduce((prev, curr) => {
      let sum = 0;
      (curr?.chart || []).forEach((item) => {
        if (typeof item?.y === "number") {
          sum += item.y;
        } else if (Array.isArray(item?.y)) {
          item.y.forEach((y) => {
            if (typeof y === "number") sum += y;
          });
        }
      });
      total += Number(sum);
      return [
        ...prev,
        {
          id: curr?._id,
          unit: curr?.unit || "",
          label: curr?._id,
          value: Number(sum.toFixed(2)),
        },
      ];
    }, []);

    temp = temp.map((item) => {
      item.y = total > 0 ? Number(((item.value * 100) / total).toFixed(2)) : 0;
      return item;
    });
    setDataPoints(temp);

    // const generateUniqueColors = (count) => {
    //   const baseColor = "#3498db"; // You can set a base color for variation
    //   const colorScale = chroma.scale(["white", baseColor]).mode("lab");
    //   return colorScale.colors(count);
    // };
    // setColors(generateUniqueColors(temp.length));
  }, [data]);

  const chartContainerRef = useRef(null);
  const chartRef = useRef(null);

  const options = {
    colorSet: "pieShades",
    animationEnabled: true,
    animationDuration: 1000,
    theme: isDark ? "dark2" : "light1",

    height: height - 50 || chartContainerRef.current?.clientHeight - 50 || 250,
    legend: {
      horizontalAlign: legendPosition.split(" ")[0] || "right", // left, center ,right
      verticalAlign: legendPosition.split(" ")[1] || "center", // top, center, bottom,
      fontSize: 12,
      fontColor: "#b1adad",
      fontWeight: "normal",
    },
    toolTip: {
      shared: true,
      cornerRadius: 4,
    },
    data: [
      {
        type: doughnut ? "doughnut" : "pie",
        startAngle: 75,
        toolTipContent: showPercentage ? "<b>{label}</b>: {y}%" : "<b>{label}</b>",
        showInLegend: legendPosition !== "hide",
        legendText: showValue ? "{label} - {value} {unit}" : "{label}",
        legend: {
          horizontalAlign: legendPosition.split(" ")[0] || "center", // left, center ,right
          verticalAlign: legendPosition.split(" ")[1] || "bottom", // top, center, b
        },
        indexLabelFontSize: 12,
        indexLabelFontColor: "#b1adad",
        indexLabel: showPercentage ? "{label} - {y}%" : "{label}",
        dataPoints,
      },
    ],
  };
  return (
    <Spin spinning={isLoading}>
      <div
        className="nodrag nopan nowheel"
        ref={chartContainerRef}
        style={{ position: "relative", width: "100%", height: "100%", cursor: "auto" }}
        key={"pie" + new Date().getTime()}
        onMouseDown={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
      >
        <CanvasJSChart
          options={options}
          onRef={(chart) => (chartRef.current = chart)}
          containerProps={{ width: "100%" }}
        />
      </div>
    </Spin>
  );
};

export default CanvasjsPieChart;

CanvasjsPieChart.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  isDark: PropTypes.bool,
  height: PropTypes.number,
  legendPosition: PropTypes.string,
  colorSchema: PropTypes.string,
  doughnut: PropTypes.bool,
  showPercentage: PropTypes.bool,
  showValue: PropTypes.bool,
};
